<app-driver-activity [title]="'driverDashboard.widgets.driversInYard' | transloco" [count]="count" [icon]="'ph-warehouse'" [columnHeaders]="columnHeaders"
  [filteredDriversData]="filteredDriversData" [isModal]="isModal" [componentId]="componentId"
  (toggleExpandEvent)="onExpand($event)" [isLoading]="isLoading" [isPageLoading]="isFetching"
  (scrollEvent)="onScroll()" [isLocationColumn]="true" [hasError]="hasError">
</app-driver-activity>